/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEditPlus = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 6.4 17.6 2l-4.2 4.2L2 17.6V22h4.4l11.4-11.3zm-4.4-1.6 1.6 1.6-2.1 2.1-1.6-1.6zM5.6 20H4v-1.6l10.1-10 1.6 1.6zM20 16h-2v2h-2v2h2v2h2v-2h2v-2h-2z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgEditPlus as EditPlus };
